import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isReadOnlyPreview } from '../../config';

const publicPreviewPaths = [
  /^\/home-settings\/(header-message|section|carousel|trending-products|newsletter)\/?$/,
  /^\/categories\/(active|home)\/?$/,
  /^\/products\/?$/,
  /^\/products\/([a-f0-9]{24}|recommended|random|search\/suggestions)\/?$/i,
  /^\/product-reviews\/product\/[a-f0-9]{24}\/?$/i,
  /^\/exchange-rates\/current\/?$/,
];

export function isAllowedPreviewRequest(args, baseUrl) {
  const method = typeof args === 'string' ? 'GET' : String(args.method || 'GET').toUpperCase();
  if (!['GET', 'HEAD'].includes(method)) return false;
  const endpoint = typeof args === 'string' ? args : args.url;
  try {
    const href = /^https?:\/\//i.test(endpoint) ? endpoint : `${baseUrl.replace(/\/$/, '')}/${endpoint.replace(/^\//, '')}`;
    const url = new URL(href, window.location.origin);
    if (!url.pathname.startsWith('/api/v1/')) return false;
    return publicPreviewPaths.some((pattern) => pattern.test(url.pathname.slice('/api/v1'.length)));
  } catch { return false; }
}

export function prepareApiHeaders(headers, { getState }) {
  const auth = getState()?.authSlice;
  const token = auth?.token || auth?.user?.token;
  if (typeof token === 'string' && token.trim() && !['null', 'undefined'].includes(token)) {
    headers.set('Authorization', `Bearer ${token}`);
  } else {
    headers.delete('Authorization');
  }
  return headers;
}

export function createBaseQuery(options, { readOnlyPreview = isReadOnlyPreview } = {}) {
  const query = fetchBaseQuery({
    ...options,
    timeout: 20000,
    // A missing session must never be sent as "Bearer null" on guest requests.
    prepareHeaders: (headers, api) => {
      if (readOnlyPreview) { headers.delete('Authorization'); return headers; }
      return prepareApiHeaders(headers, api);
    },
  });
  return (args, api, extraOptions) => {
    if (readOnlyPreview && !isAllowedPreviewRequest(args, options.baseUrl)) {
      return { error: { status: 403, data: { success: false, message: 'Åtgärden är avstängd i förhandsvisningen. Endast den offentliga katalogen är tillgänglig.' } } };
    }
    return query(args, api, extraOptions);
  };
}
